import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Grid,
  DialogActions,
  Button,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import { Close, Store } from "@mui/icons-material";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import InputText from "components/_refactor/text/input";
import StructureFields from "components/_refactor/fields/structure";

export default function DialogCreateEdit({ onClose, franchise }) {
  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    schemaBaseSeta: "",
    idEmpresaSeta: "",
    ativo: true,
  });

  const snackbar = useSnackbar();
  const title = franchise ? "Editar Franquia" : "Incluir Nova Franquia";

  console.log("franchise", franchise);

  useEffect(() => {
    if (franchise) {
      setFormData({
        schemaBaseSeta: franchise.SchemaBaseSeta || "",
        idEmpresaSeta: franchise.IdEmpresaSeta || "",
        ativo: franchise.Ativo ?? true,
      });
      setStructureFilters({
        idLojaUnica: franchise.IdPessoaLoja || "",
        idGrupoEconomico: franchise.IdGrupoEconomico || "",
      });
      setStructureLoading([]);
    }
  }, [franchise]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const body = {
        idFranquiaConfiguracao: franchise?.IdFranquiaConfiguracao || null,
        idPessoaLoja: structureFilters?.idLojaUnica,
        schemaBaseSeta: formData.schemaBaseSeta,
        idEmpresaSeta: formData.idEmpresaSeta,
        idGrupoEconomico: structureFilters?.idGrupoEconomico,
        ativo: formData.ativo,
      };

      await Api.post("edit-franchise-config", "configuracoesOmni", body, true);

      snackbar.showMessage(
        franchise
          ? "Franquia editada com sucesso"
          : "Franquia criada com sucesso",
        { severity: "success" }
      );
      handleClear();
      onClose(true);
    } catch (error) {
      snackbar.showMessage(
        "Erro ao salvar a franquia: " + (error.message || error),
        {
          severity: "error",
        }
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setClearFilters(true);
    setFormData({
      schemaBaseSeta: "",
      idEmpresaSeta: "",
      ativo: true,
    });
    setStructureFilters({});
    setStructureLoading([]);
    setTimeout(() => {
      setClearFilters(false);
    }, 100);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="lg">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Store style={{ marginRight: "12px" }} />
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <StructureFields
            clearFilters={clearFilters}
            onStructureFieldsChange={setStructureFilters}
            disableAll={!!structureLoading?.length}
            onStructureFieldsLoad={setStructureLoading}
            requiredFields={["storeSingle"]}
            hideFields={["brand", "channel", "representative", "store"]}
            handleSearch={() => {}}
            showSingleStore
            franquias
            defaultEconomicGroup={franchise?.IdGrupoEconomico}
            singleStoreId={franchise?.IdPessoaLoja}
          />
          <Grid item xs={12} md={4}>
            <InputText
              label="Schema Base Seta"
              value={formData.schemaBaseSeta}
              onChange={(e) => handleChange("schemaBaseSeta", e.target.value)}
              disabled={loading}
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputText
              label="ID Empresa Seta"
              value={formData.idEmpresaSeta}
              onChange={(e) => handleChange("idEmpresaSeta", e.target.value)}
              disabled={loading}
              required
              type="number"
              props={{
                inputProps: {
                  min: 0,
                },
              }}
            />
          </Grid>
          <Grid item xs={3} justify="center" style={{ marginTop: "1.3rem" }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.ativo}
                    onChange={(e) => handleChange("ativo", e.target.checked)}
                    name="ativo"
                    color="primary"
                    disabled={loading}
                  />
                }
                style={{ marginLeft: "0" }}
                label={
                  <Typography variant="body1" style={{ marginLeft: "0.5rem" }}>
                    Franquia Ativada
                  </Typography>
                }
              />
            </FormGroup>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            handleClear();
            onClose();
          }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={
            loading ||
            !formData.schemaBaseSeta ||
            !formData.idEmpresaSeta ||
            !structureFilters?.idLojaUnica ||
            !structureFilters?.idGrupoEconomico
          }
        >
          {franchise ? "Editar" : "Criar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
